const { default: createApi } = require("./api");

const api = createApi({
  baseUrl: 'reports',
  headers: {
    'Content-Type': 'application/json'
  },
});

export default class SearchService {
  
  async search({ query }) {
    return api.post('search', { query });
  }
}
